import { render, staticRenderFns } from "./conversation-item.vue?vue&type=template&id=0520fa83&"
import script from "./conversation-item.vue?vue&type=script&lang=js&"
export * from "./conversation-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports